// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"StaticPage-module__pageContainer___1qFlZ","staticPage":"StaticPage-module__staticPage___3MxrX","staticPage__background":"StaticPage-module__staticPage__background___JDFC6","staticPage__content":"StaticPage-module__staticPage__content___3_W2O"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/StaticPage/StaticPage.module.css
// module id = 653
// module chunks = 0